module.exports = __webpack_public_path__ + "static/media/p2_s3a.4e05607d.ogg";